import {isNil} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';

import styles from './IntegerFormatter.less';
import baseIntegerFormatterParams from 'src/js/lib/raw_rendering/base_integer_formatter_params';

class IntegerFormatter extends React.PureComponent {
  render() {
    const {value, formattedValue} = baseIntegerFormatterParams(this.props);
    return !isNil(value) ? (
      <div className={styles.dlIntegerFormatter} title={formattedValue}>
        {formattedValue}
      </div>
    ) : (
      ''
    );
  }
}

IntegerFormatter.displayName = 'IntegerFormatter';

/* eslint-disable react/no-unused-prop-types */
IntegerFormatter.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

IntegerFormatter.defaultProps = {
  value: undefined,
};

export default IntegerFormatter;
